import { ArrowRightIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { clinic } from '../data/clinic';
import { BrandMark } from './BrandMark';
interface CoverScreenProps {
  layout: 'split' | 'centered';
  onStart: () => void;
}
export function CoverScreen({
  layout,
  onStart
}: CoverScreenProps) {
  const centered = layout === 'centered';
  return <section className={centered ? 'flex min-h-screen w-full items-center justify-center bg-olive-800 px-6 py-20 sm:px-10' : 'grid min-h-screen w-full grid-cols-1 bg-olive-800 lg:grid-cols-[1.1fr_1fr]'} data-id="element-9" data-mp="1612o3pb14cz4">
      <div className={centered ? 'w-full max-w-2xl text-center' : 'flex items-center px-6 py-16 sm:px-12 lg:px-20 lg:py-24'} data-id="element-10" data-mp="1jsha8508guae">
        <div className={centered ? '' : 'max-w-xl'} data-id="element-11" data-mp="8cso1fuszzan">
          <BrandMark size="lg" className={centered ? 'items-center text-center' : ''} data-id="element-12" data-mp="8b7spo0o0cbq" />

          <p className="mt-12 font-sans text-[11px] uppercase tracking-widest2 text-cream-100/60" data-id="element-13" data-mp="dcosfg7exsqq">
            {clinic.formName}
          </p>

          <h1 className="mt-4 font-display text-5xl leading-[1.05] text-cream-50 sm:text-6xl" data-id="element-14" data-mp="1c5ezirf8ml6z">
            {clinic.specialistName}
          </h1>
          <p className="mt-3 font-sans text-xs uppercase tracking-[0.2em] text-cream-100/70" data-id="element-15" data-mp="1m2t3vsnvzjix">
            {clinic.specialistRole}
          </p>

          <p className="mt-4 inline-flex items-center gap-2 font-sans text-xs text-cream-100/50" data-id="element-16" data-mp="1h51ep6emmbif">
            <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-17" data-mp="1v03gpigcrgpy" />
            {clinic.location}
            <span aria-hidden="true" data-id="element-18" data-mp="1qz1rlug5gl1p">·</span>
            {clinic.credential}
          </p>

          <div className={`mt-8 h-px w-16 bg-gold-400 ${centered ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-19" data-mp="24udkdwaqw1fz" />

          <p className="mt-8 font-display text-2xl leading-relaxed text-cream-100 sm:text-[26px]" data-id="element-20" data-mp="2epxgojt81259">
            {clinic.welcome}
          </p>

          <div className={`mt-12 flex flex-wrap items-center gap-6 ${centered ? 'justify-center' : ''}`} data-id="element-21" data-mp="29sx5juhil97a">
            <button type="button" onClick={onStart} className="group inline-flex items-center gap-3 rounded-sm bg-cream-100 px-8 py-4 font-sans text-sm uppercase tracking-[0.2em] text-olive-800 transition-colors duration-200 ease-soft hover:bg-cream-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2 focus-visible:ring-offset-olive-800" data-id="element-22" data-mp="2gspqnpeva6f2">
              Começar
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-soft group-hover:translate-x-1" aria-hidden="true" data-id="element-23" data-mp="34ik0rz7sxgvm" />
            </button>

            <span className="inline-flex items-center gap-2 font-sans text-xs uppercase tracking-[0.18em] text-cream-100/55" data-id="element-24" data-mp="3ehj9fhskhcim">
              <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-25" data-mp="1k49ydlkdhiy9" />
              {clinic.duration}
            </span>
          </div>
        </div>
      </div>

      {!centered && <div className="relative hidden lg:block" data-id="element-26" data-mp="1cmvap8uypgec">
          <img src={clinic.coverImage} alt={`${clinic.specialistName} na clínica`} className="absolute inset-0 h-full w-full object-cover" data-id="element-27" data-mp="17t0tqd6qrfiy" />
        </div>}
    </section>;
}